/* React */
import React, { useState } from 'react';
import { TooltipSortArrow } from '../SortArrow';

// components
import ClassroomDetailsItem from './ClassroomDetailsItem';

// styles
import {
  ListHeaderClassrooms,
  ClassroomDetailsList,
  ClassroomDetailsListHeader,
  ClassroomDetailsListHeaderName,
} from './styles/ClassroomDetails';
import { EmptyList } from '../sharedComponents/styles/EmptyList';

interface ClassroomDetailsListProps {
  listData: any;
  onClickItem: any;
  onDeleteItem: any;
  emptyMessage: string;
  onSelectItem?: any;
  defaultItemAvatar?: any;
  tableColumnHeaders: any;
  selectedItems?: any;
  withCheckboxItems?: boolean;
}

const ClassroomDetailsListComponent: React.FC<ClassroomDetailsListProps> = ({
  listData,
  onClickItem,
  onDeleteItem,
  onSelectItem,
  selectedItems,
  defaultItemAvatar,
  tableColumnHeaders,
  withCheckboxItems = false,
  emptyMessage = 'Nothing to show yet...',
}) => {
  const [alphaSort, setAlphaSort] = useState(false);

  /* sort centers alphabetically */
  const sortedClassrooms = listData?.sort((a: any, b: any) =>
    a?.name?.localeCompare(b?.name),
  );

  const onDeleteDetailsItem = (itemId: number) => {
    onDeleteItem && onDeleteItem(itemId);
  };

  /* SORT item list */
  const renderListData = (list: any) =>
    list.map((item: any, index: number) => (
      <ClassroomDetailsItem
        key={index}
        item={item}
        onSelectItem={onSelectItem}
        selectedItems={selectedItems}
        onClickDetailsItem={onClickItem}
        withCheckboxItems={withCheckboxItems}
        defaultItemAvatar={defaultItemAvatar}
        onDeleteDetailsItem={onDeleteDetailsItem}
      />
    ));

  return (
    <ClassroomDetailsList>
      <ClassroomDetailsListHeader>
        {tableColumnHeaders.map(({ title, withSortButton }: any) => (
          <ClassroomDetailsListHeaderName>
            <ListHeaderClassrooms>{title}</ListHeaderClassrooms>
            {withSortButton && (
              <TooltipSortArrow sorted={alphaSort} onSort={setAlphaSort} />
            )}
          </ClassroomDetailsListHeaderName>
        ))}
      </ClassroomDetailsListHeader>
      {listData?.length > 0 ? (
        renderListData(
          alphaSort ? sortedClassrooms?.reverse() : sortedClassrooms,
        )
      ) : (
        <EmptyList>{emptyMessage}</EmptyList>
      )}
    </ClassroomDetailsList>
  );
};

export default ClassroomDetailsListComponent;
